export default __webpack_public_path__ + "static/media/import_white.b395c223.svg";